export default __webpack_public_path__ + "static/media/donator_eodopen.b21115c8.png";